import Blamable            from '@/models/traits/Blamable';
import MapServiceModel     from '@/models/MapServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import WithProjectPagePath from '@/models/traits/WithProjectPagePath';
import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';

@model.urnResource('map')
@doc.path('/maps/{?id}')
export default class MapModel extends Blamable(TimestampAble(WithProjectPagePath(MapServiceModel))) {
	private declare _tsFilters: {
		'createdAt': string;
		'mapPlaces': id;
		'mapStatus': id;
		'mapVersions': id;
		'project': id;
		'project.owner.accountUrn': string;
		'updatedAt': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'position': string;
		'updatedAt': string;
	};

	@doc.string declare label: string;
	@doc.number declare position: number;
}
